import {ENTITY_SERVICE_REGISTRY, EntityServiceEntry} from "../../core/shared/dto/dto-service/entity-service-registry";

export const AC_ENTITY_SERVICE_PROVIDERS = [
    {
        provide: ENTITY_SERVICE_REGISTRY,
        useValue: [
            [
                'ac.AcTemplateAcquisitionCommission',
                {route: '/ac/config'}
            ],
            [
                'ac.AcAgentCancellationBufferAssignment',
                {route: '/ac/config'}
            ],
            [
                'ac.AcAcquisitionCommissionAssignment',
                {route: '/ac/config'}
            ]
        ] as EntityServiceEntry[],
        multi: true
    }
];
